import script from "./PurchasedHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasedHeader.vue?vue&type=script&setup=true&lang=js"

import "./PurchasedHeader.vue?vue&type=style&index=0&id=b15b45e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b15b45e4"]])

export default __exports__